import { SafeHtml } from '@angular/platform-browser';

export interface DrawerMenuItem {
  label: string;
  id?: number;
  icon?: string | SafeHtml;
  // Use only route and pattern OR children. Menu items having children do not have navigation capabilities
  route?: string;
  pattern?: RegExp;
  children?: DrawerMenuItem[];
}
